export const passwordRegex =
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})";

export const validatePassword = (value) => {
  const regex = new RegExp(passwordRegex);
  return regex.test(value);
};
